import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuard implements CanActivate {

  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const requiredFlag = route.data['featureFlag'];

    if (!requiredFlag) {
      // If the route doesn't specify a flag, allow access
      return true;
    }

    return this.featureFlagService.watchFlag(requiredFlag).pipe(
      map(isEnabled => {
        if (isEnabled) {
          return true;
        } else {
          // If disabled, redirect to dashboard or home, or simply block.
          this.router.navigate(['/']); // Redirect to home/dashboard
          return false;
        }
      })
    );
  }
}
